module.exports = __webpack_public_path__ + "static/lesley-barber-social-media-64671255c848a2b23e5832d3b61e1013.jpg";